"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowFormatter = void 0;
var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var FieldFormatter_1 = require("./FieldFormatter");
var types_1 = require("../types");
var RowFormatter = /*#__PURE__*/function () {
  function RowFormatter(formatterOptions) {
    _classCallCheck(this, RowFormatter);
    this.rowCount = 0;
    this.formatterOptions = formatterOptions;
    this.fieldFormatter = new FieldFormatter_1.FieldFormatter(formatterOptions);
    this.headers = formatterOptions.headers;
    this.shouldWriteHeaders = formatterOptions.shouldWriteHeaders;
    this.hasWrittenHeaders = false;
    if (this.headers !== null) {
      this.fieldFormatter.headers = this.headers;
    }
    if (formatterOptions.transform) {
      this.rowTransform = formatterOptions.transform;
    }
  }
  _createClass(RowFormatter, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (!lodash_isfunction_1.default(transformFunction)) {
        throw new TypeError('The transform should be a function');
      }
      this._rowTransform = RowFormatter.createTransform(transformFunction);
    }
  }, {
    key: "format",
    value: function format(row, cb) {
      var _this = this;
      this.callTransformer(row, function (err, transformedRow) {
        if (err) {
          return cb(err);
        }
        if (!row) {
          return cb(null);
        }
        var rows = [];
        if (transformedRow) {
          var _this$checkHeaders = _this.checkHeaders(transformedRow),
            shouldFormatColumns = _this$checkHeaders.shouldFormatColumns,
            headers = _this$checkHeaders.headers;
          if (_this.shouldWriteHeaders && headers && !_this.hasWrittenHeaders) {
            rows.push(_this.formatColumns(headers, true));
            _this.hasWrittenHeaders = true;
          }
          if (shouldFormatColumns) {
            var columns = _this.gatherColumns(transformedRow);
            rows.push(_this.formatColumns(columns, false));
          }
        }
        return cb(null, rows);
      });
    }
  }, {
    key: "finish",
    value: function finish(cb) {
      var rows = [];
      // check if we should write headers and we didnt get any rows
      if (this.formatterOptions.alwaysWriteHeaders && this.rowCount === 0) {
        if (!this.headers) {
          return cb(new Error('`alwaysWriteHeaders` option is set to true but `headers` option not provided.'));
        }
        rows.push(this.formatColumns(this.headers, true));
      }
      if (this.formatterOptions.includeEndRowDelimiter) {
        rows.push(this.formatterOptions.rowDelimiter);
      }
      return cb(null, rows);
    }
    // check if we need to write header return true if we should also write a row
    // could be false if headers is true and the header row(first item) is passed in
  }, {
    key: "checkHeaders",
    value: function checkHeaders(row) {
      if (this.headers) {
        // either the headers were provided by the user or we have already gathered them.
        return {
          shouldFormatColumns: true,
          headers: this.headers
        };
      }
      var headers = RowFormatter.gatherHeaders(row);
      this.headers = headers;
      this.fieldFormatter.headers = headers;
      if (!this.shouldWriteHeaders) {
        // if we are not supposed to write the headers then
        // always format the columns
        return {
          shouldFormatColumns: true,
          headers: null
        };
      }
      // if the row is equal to headers dont format
      return {
        shouldFormatColumns: !lodash_isequal_1.default(headers, row),
        headers: headers
      };
    }
    // todo change this method to unknown[]
  }, {
    key: "gatherColumns",
    value: function gatherColumns(row) {
      if (this.headers === null) {
        throw new Error('Headers is currently null');
      }
      if (!Array.isArray(row)) {
        return this.headers.map(function (header) {
          return row[header];
        });
      }
      if (RowFormatter.isRowHashArray(row)) {
        return this.headers.map(function (header, i) {
          var col = row[i];
          if (col) {
            return col[1];
          }
          return '';
        });
      }
      // if its a one dimensional array and headers were not provided
      // then just return the row
      if (RowFormatter.isRowArray(row) && !this.shouldWriteHeaders) {
        return row;
      }
      return this.headers.map(function (header, i) {
        return row[i];
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }
      return this._rowTransform(row, cb);
    }
  }, {
    key: "formatColumns",
    value: function formatColumns(columns, isHeadersRow) {
      var _this2 = this;
      var formattedCols = columns.map(function (field, i) {
        return _this2.fieldFormatter.format(field, i, isHeadersRow);
      }).join(this.formatterOptions.delimiter);
      var rowCount = this.rowCount;
      this.rowCount += 1;
      if (rowCount) {
        return [this.formatterOptions.rowDelimiter, formattedCols].join('');
      }
      return formattedCols;
    }
  }], [{
    key: "isRowHashArray",
    value: function isRowHashArray(row) {
      if (Array.isArray(row)) {
        return Array.isArray(row[0]) && row[0].length === 2;
      }
      return false;
    }
  }, {
    key: "isRowArray",
    value: function isRowArray(row) {
      return Array.isArray(row) && !this.isRowHashArray(row);
    }
    // get headers from a row item
  }, {
    key: "gatherHeaders",
    value: function gatherHeaders(row) {
      if (RowFormatter.isRowHashArray(row)) {
        // lets assume a multi-dimesional array with item 0 being the header
        return row.map(function (it) {
          return it[0];
        });
      }
      if (Array.isArray(row)) {
        return row;
      }
      return Object.keys(row);
    }
    // eslint-disable-next-line @typescript-eslint/no-shadow
  }, {
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if (types_1.isSyncTransform(transformFunction)) {
        return function (row, cb) {
          var transformedRow = null;
          try {
            transformedRow = transformFunction(row);
          } catch (e) {
            return cb(e);
          }
          return cb(null, transformedRow);
        };
      }
      return function (row, cb) {
        transformFunction(row, cb);
      };
    }
  }]);
  return RowFormatter;
}();
exports.RowFormatter = RowFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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